"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowFormatter = void 0;
var lodash_isfunction_1 = __importDefault(require("lodash.isfunction"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var FieldFormatter_1 = require("./FieldFormatter");
var types_1 = require("../types");
var RowFormatter = /*#__PURE__*/function () {
  function RowFormatter(formatterOptions) {
    _classCallCheck(this, RowFormatter);
    this.rowCount = 0;
    this.formatterOptions = formatterOptions;
    this.fieldFormatter = new FieldFormatter_1.FieldFormatter(formatterOptions);
    this.headers = formatterOptions.headers;
    this.shouldWriteHeaders = formatterOptions.shouldWriteHeaders;
    this.hasWrittenHeaders = false;
    if (this.headers !== null) {
      this.fieldFormatter.headers = this.headers;
    }
    if (formatterOptions.transform) {
      this.rowTransform = formatterOptions.transform;
    }
  }
  _createClass(RowFormatter, [{
    key: "rowTransform",
    set: function set(transformFunction) {
      if (!lodash_isfunction_1.default(transformFunction)) {
        throw new TypeError('The transform should be a function');
      }
      this._rowTransform = RowFormatter.createTransform(transformFunction);
    }
  }, {
    key: "format",
    value: function format(row, cb) {
      var _this = this;
      this.callTransformer(row, function (err, transformedRow) {
        if (err) {
          return cb(err);
        }
        if (!row) {
          return cb(null);
        }
        var rows = [];
        if (transformedRow) {
          var _this$checkHeaders = _this.checkHeaders(transformedRow),
            shouldFormatColumns = _this$checkHeaders.shouldFormatColumns,
            headers = _this$checkHeaders.headers;
          if (_this.shouldWriteHeaders && headers && !_this.hasWrittenHeaders) {
            rows.push(_this.formatColumns(headers, true));
            _this.hasWrittenHeaders = true;
          }
          if (shouldFormatColumns) {
            var columns = _this.gatherColumns(transformedRow);
            rows.push(_this.formatColumns(columns, false));
          }
        }
        return cb(null, rows);
      });
    }
  }, {
    key: "finish",
    value: function finish(cb) {
      var rows = [];
      // check if we should write headers and we didnt get any rows
      if (this.formatterOptions.alwaysWriteHeaders && this.rowCount === 0) {
        if (!this.headers) {
          return cb(new Error('`alwaysWriteHeaders` option is set to true but `headers` option not provided.'));
        }
        rows.push(this.formatColumns(this.headers, true));
      }
      if (this.formatterOptions.includeEndRowDelimiter) {
        rows.push(this.formatterOptions.rowDelimiter);
      }
      return cb(null, rows);
    }
    // check if we need to write header return true if we should also write a row
    // could be false if headers is true and the header row(first item) is passed in
  }, {
    key: "checkHeaders",
    value: function checkHeaders(row) {
      if (this.headers) {
        // either the headers were provided by the user or we have already gathered them.
        return {
          shouldFormatColumns: true,
          headers: this.headers
        };
      }
      var headers = RowFormatter.gatherHeaders(row);
      this.headers = headers;
      this.fieldFormatter.headers = headers;
      if (!this.shouldWriteHeaders) {
        // if we are not supposed to write the headers then
        // always format the columns
        return {
          shouldFormatColumns: true,
          headers: null
        };
      }
      // if the row is equal to headers dont format
      return {
        shouldFormatColumns: !lodash_isequal_1.default(headers, row),
        headers: headers
      };
    }
    // todo change this method to unknown[]
  }, {
    key: "gatherColumns",
    value: function gatherColumns(row) {
      if (this.headers === null) {
        throw new Error('Headers is currently null');
      }
      if (!Array.isArray(row)) {
        return this.headers.map(function (header) {
          return row[header];
        });
      }
      if (RowFormatter.isRowHashArray(row)) {
        return this.headers.map(function (header, i) {
          var col = row[i];
          if (col) {
            return col[1];
          }
          return '';
        });
      }
      // if its a one dimensional array and headers were not provided
      // then just return the row
      if (RowFormatter.isRowArray(row) && !this.shouldWriteHeaders) {
        return row;
      }
      return this.headers.map(function (header, i) {
        return row[i];
      });
    }
  }, {
    key: "callTransformer",
    value: function callTransformer(row, cb) {
      if (!this._rowTransform) {
        return cb(null, row);
      }
      return this._rowTransform(row, cb);
    }
  }, {
    key: "formatColumns",
    value: function formatColumns(columns, isHeadersRow) {
      var _this2 = this;
      var formattedCols = columns.map(function (field, i) {
        return _this2.fieldFormatter.format(field, i, isHeadersRow);
      }).join(this.formatterOptions.delimiter);
      var rowCount = this.rowCount;
      this.rowCount += 1;
      if (rowCount) {
        return [this.formatterOptions.rowDelimiter, formattedCols].join('');
      }
      return formattedCols;
    }
  }], [{
    key: "isRowHashArray",
    value: function isRowHashArray(row) {
      if (Array.isArray(row)) {
        return Array.isArray(row[0]) && row[0].length === 2;
      }
      return false;
    }
  }, {
    key: "isRowArray",
    value: function isRowArray(row) {
      return Array.isArray(row) && !this.isRowHashArray(row);
    }
    // get headers from a row item
  }, {
    key: "gatherHeaders",
    value: function gatherHeaders(row) {
      if (RowFormatter.isRowHashArray(row)) {
        // lets assume a multi-dimesional array with item 0 being the header
        return row.map(function (it) {
          return it[0];
        });
      }
      if (Array.isArray(row)) {
        return row;
      }
      return Object.keys(row);
    }
    // eslint-disable-next-line @typescript-eslint/no-shadow
  }, {
    key: "createTransform",
    value: function createTransform(transformFunction) {
      if (types_1.isSyncTransform(transformFunction)) {
        return function (row, cb) {
          var transformedRow = null;
          try {
            transformedRow = transformFunction(row);
          } catch (e) {
            return cb(e);
          }
          return cb(null, transformedRow);
        };
      }
      return function (row, cb) {
        transformFunction(row, cb);
      };
    }
  }]);
  return RowFormatter;
}();
exports.RowFormatter = RowFormatter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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